<!-- ================== HERO SECTION ================== -->
<div class="ai-section-bg">
  <section class="ai-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <!-- Left Text Section -->
        <div class="col-lg-5">
          <h1 class="ai-heading mb-3">
            Build AI-powered Solutions & Grow with Our Collaborative Culture
          </h1>
          <!-- <h6 class="ai-subheading1 mb-3">
            & Grow with Our Collaborative Culture
          </h6> -->
          <p class="ai-subheading2 mb-4">
            At Kalpita Technologies, we build software that impacts millions while fostering a culture of
            learning, inclusivity, and growth for every employee.

          </p>
          <!-- Buttons Row -->
          <div class="button-row mb-4">
            <button class="btn btn-gradient btn-custom fw-semibold" (click)="viewOpenPositions()">
              View Open Positions
            </button>
            <!-- <button class="btn btn-outline-glass btn-custom fw-semibold">
              Share Your Resume
            </button>
            <button class="btn btn-upload-icon d-flex align-items-center justify-content-center">
              <img src="assets/CareersAtKalpita/upload.png" alt="Upload" class="custom-upload-icon">
            </button> -->

          </div>
          <p class="ai-footer-text small mb-0">
            GPTW | Glassdoor (4.5) | Ambition Box (4.2) | Google (4.7) | NFP | Optimized Payments | Great Gray + RPAG
          </p>
        </div>
        <!-- Right Image Section -->
        <div class="col-lg-7 text-center">
          <video #heroVideo preload="auto" src="../../../../assets/CareersAtKalpita/careerAtKalpita.webm" class="img-fluid hero-image"
            autoplay loop muted playsinline disablePictureInPicture>
          </video>
        </div>
      </div>
    </div>
  </section>
</div>
<!-- ================== CAREER BREAKTHROUGH SECTION ================== -->
<section class="career-breakthrough-section">
  <div class="container">
    <h2 class="section-main-heading text-center mb-5">Find Your Next Career Breakthrough At Kalpita</h2>
    <div class="row align-items-center">

      <!-- LEFT SIDE TEXT -->
      <div class="col-md-6 career-text">
        <!-- <h4 class="sub-heading">
          Looking for a career breakthrough<br />
          where your skills truly make an impact?
        </h4> -->
        <p class="career-desc">
          Looking for a career breakthrough where your skills truly make an impact? Join Kalpita Technologies, the Great
          Place to Work-Certified, AI-focused software company where you don’t just code but create.
        </p>
        <p class="career-desc">
          Your career journey awaits here with learning and growth hand-in-hand. Let’s build the future together with
          creativity and technology.
        </p>
      </div>

      <!-- RIGHT SIDE IMAGE -->
      <div class="col-md-6 text-center">
        <img src="assets/CareersAtKalpita/GirlWorkingInShell.png" alt="Girl working in AI pod"
          class="career-img img-fluid" />
      </div>

    </div>
  </div>
</section>
<!-- ================== EXPLORE PRIORITY ROLES SECTION ================== -->
<section class="priority-roles-section py-5">
  <div class="container">
    <h2 class="section-heading text-center mb-5">Explore Our Priority Roles</h2>
    
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <!-- Job List -->
        <div class="priority-jobs-list">
          
          <div class="job-card" *ngFor="let job of priorityJobs">
            <div class="job-info">
              <h4 class="job-title">{{ job.JobTitle }}</h4>
              <p class="job-meta">
                <span class="job-exp">{{ job.Experience }}</span>
                <span class="separator">|</span>
                <span class="job-loc">{{ job.Location }}</span>
              </p>
            </div>
            <button class="btn btn-apply" (click)="applyForJob(job.JobId)">Apply Now</button>
          </div>

        </div>
        
        <!-- View All Link (Optional) -->
        <div class="text-center mt-4">
          <button class="btn btn-view-all" (click)="viewOpenPositions()">View all open positions</button>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- ================== LIFE AT KALPITA SECTION ================== -->
<section class="life-section text-center py-5">
  <h2 class="fw-bold mb-5">Life at Kalpita Technologies</h2>

  <div class="container">
    <div class="row justify-content-center g-4">
      <!-- Cards rendered from TS -->
      <div class="col-md-4" *ngFor="let item of lifeAtKalpitaCards; let idx = index">
        
        <!-- ADDED: (click) event to navigate -->
        <div class="life-card" (click)="navigateTo(item.route)">
          <div class="img-container">
            <img [src]="item.img" [alt]="item.title">
          </div>
          <div class="card-footer">
            <h5>{{ item.title }}</h5>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
<!-- What Our People Say About Working at Kalpita Technologies -->
<!-- ================== EMPLOYEE PERKS & BENEFITS SECTION ================== -->
<section class="perks-section py-5">
  <div class="container">
    
    <!-- Header -->
    <div class="row justify-content-center mb-5">
      <div class="col-lg-10 text-center">
        <h2 class="section-heading mb-3">Employee Perks & Benefits</h2>
        <p class="section-subheading">
          At Kalpita Technologies, our perks and benefits are thoughtfully designed to support every aspect of our employees’ journey, both professionally and personally. From career growth opportunities to wellbeing programs, we ensure a healthy balance between work and life.
        </p>
      </div>
    </div>

    <!-- Perks Grid: 4 items per row (col-lg-3) -->
    <div class="row g-4">
      <div class="col-lg-3 col-md-6 col-sm-12" *ngFor="let perk of perksList">
        <div class="perk-card h-100">
          <div class="perk-icon-wrapper mb-3">
            <img [src]="perk.icon" [alt]="perk.title" class="perk-icon">
          </div>
          <h5 class="perk-title">{{ perk.title }}</h5>
          <p class="perk-desc">{{ perk.description }}</p>
        </div>
      </div>
    </div>

  </div>
</section>
<!-- ================== HIRING PROCESS SECTION ================== -->
<section class="hiring-process-section py-5">
  <div class="container">
    <!-- Section Header -->
    <div class="row justify-content-center text-center mb-5">
      <div class="col-lg-10">
        <h2 class="section-heading">Kalpita Hiring Process: 6 Simple Steps to Get Hired</h2>
        <p class="section-subheading mt-3">
          Curious about how to get hired at Kalpita Technologies?<br>
          Our hiring process is simple, transparent, and designed to help you showcase your best skills.<br>
          Here's what you can expect,
        </p>
      </div>
    </div>

    <!-- 
      ROW-WISE LAYOUT:
      Single row wrapper. 
      Loop specific indices [0, 3, 1, 4, 2, 5] to map the TS Array (Apply, T1, HR, Screening, T2, Offer)
      into the desired Logic: Apply(0) -> Screening(3) -> T1(1) -> T2(4) -> HR(2) -> Offer(5)
    -->
    <div class="row g-4">
      
      <div class="col-lg-6 d-flex flex-column" *ngFor="let i of [0, 3, 1, 4, 2, 5]">
        <div class="hiring-step-card flex-grow-1">
          <div class="step-icon-container">
            <img [src]="hiringSteps[i].icon" [alt]="hiringSteps[i].title" class="step-icon-image">
          </div>
          <div class="step-content">
            <h3 class="step-title">{{ hiringSteps[i].title }}</h3>
            <p class="step-description">{{ hiringSteps[i].description }}</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
<!-- FAQ Section -->
 <app-faq [faqList]="careerFaqs"></app-faq>